function createProductCollectionCarousel(section) {
  const viewport = section.querySelector(".embla__viewport");
  const prevButton = section.querySelector(".embla__prev");
  const nextButton = section.querySelector(".embla__next");

  if (!viewport || typeof EmblaCarousel !== "function") {
    console.warn("Embla: Missing required elements or EmblaCarousel not loaded.");
    return null;
  }

  const embla = EmblaCarousel(viewport, { loop: true, align: "center" });

  const updateSlideStates = () => {
    const selectedIndex = embla.selectedScrollSnap();
    section.querySelectorAll(".embla__slide").forEach((slide, index) => {
      slide.classList.toggle("is-selected", index === selectedIndex);
    });
  };

  prevButton?.addEventListener("click", () => embla.scrollPrev());
  nextButton?.addEventListener("click", () => embla.scrollNext());

  embla.on("select", updateSlideStates);
  updateSlideStates();

  return { embla };
}

function createProductCollectionGrid(section) {
  const grid = section.querySelector(".product-collection-grid");
  const gridItems = section.querySelectorAll(".product-collection-grid-item");

  if (!grid || gridItems.length === 0) return null;

  gridItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      if (!grid.classList.contains("has-been-interacted")) {
        grid.classList.add("has-been-interacted");
      }
    });
  });

  return { grid, gridItems };
}

function initSwatchInteraction(container) {
  container.addEventListener("click", (e) => {
    const swatch = e.target.closest(".pc-swatch");
    if (!swatch) return;

    const card = swatch.closest(".pc-card") || swatch.closest(".product-collection-grid-item");
    if (!card) return;

    const colorName = swatch.dataset.color?.toLowerCase();

    card.querySelectorAll(".pc-swatch").forEach((s) =>
      s.classList.toggle("active", s === swatch)
    );

    const mainImg = card.querySelector(
      ".pc-card-image:not(.pc-variant-image), .product-collection-grid-image:not(.pc-variant-image)"
    );
    const variantImgs = card.querySelectorAll(".pc-variant-image");

    let matched = false;
    variantImgs.forEach((img) => {
      const isMatch = img.dataset.variantColor?.toLowerCase() === colorName;
      img.style.display = isMatch ? "block" : "none";
      if (isMatch) matched = true;
    });

    if (mainImg) mainImg.style.display = matched ? "none" : "block";
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-collection-carousel").forEach((section) => {
    createProductCollectionCarousel(section);
  });

  document.querySelectorAll(".product-collection-parent").forEach((section) => {
    createProductCollectionGrid(section);
    initSwatchInteraction(section);
  });
});

document.addEventListener("shopify:section:load", (event) => {
  const section = event.target;
  const carouselSection = section.querySelector(".product-collection-carousel");
  if (carouselSection) createProductCollectionCarousel(carouselSection);

  const gridSection = section.querySelector(".product-collection-parent");
  if (gridSection) {
    createProductCollectionGrid(gridSection);
    initSwatchInteraction(gridSection);
  }
});
